<template>
  <div
    class="bb-popup-info"
    :style="popupStyle"
  >
    <div class="bb-popup-info__container">
      <i
        class="icon-cross bb-popup-info__close"
        @click="onClose"
      />
      <div
        v-for="item in items"
        :key="item.id"
      >
        <span class="bb-popup-info__label">{{item.label}}</span>
        {{item.value}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPopupInfoTwo',
  props: {
    items: {
      type: Array,
      default: () => ([])
    },
    popupStyle: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.bb-popup-info {
  position: absolute;
  left: 50%;
  padding: 8px;
  background: rgba($color-black, 0.55);
  font-weight: 400;
  line-height: 14px;
  font-size: 12px;
  color: $color-white;
  border-radius: 5px;
  z-index: 20;
  user-select: none;

  &:before {
    content: '';
    position: absolute;
    left: 10px;
    top: -4px;
    display: block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid rgba($color-black, 0.55);
  }

  &__container {
    display: grid;
    grid-gap: 4px 0;
    padding: 0 10px 0 0;
  }

  &__label {
    font-weight: 500;
  }

  &__close {
    position: absolute;
    right: 2px;
    top: 4px;
    color: $color-silver-new;
    cursor: pointer;
    transition: 0.2s all;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPopupInfo/BBPopupInfoTwo.vue